/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PnoEntry } from './PnoEntry';
import {
    PnoEntryFromJSON,
    PnoEntryFromJSONTyped,
    PnoEntryToJSON,
    PnoEntryToJSONTyped,
} from './PnoEntry';

/**
 * 
 * @export
 * @interface GranularPnoEntries
 */
export interface GranularPnoEntries {
    /**
     * 
     * @type {string}
     * @memberof GranularPnoEntries
     */
    currency?: string;
    /**
     * 
     * @type {{ [key: string]: PnoEntry; }}
     * @memberof GranularPnoEntries
     */
    pnoEntries?: { [key: string]: PnoEntry; };
}

/**
 * Check if a given object implements the GranularPnoEntries interface.
 */
export function instanceOfGranularPnoEntries(value: object): value is GranularPnoEntries {
    return true;
}

export function GranularPnoEntriesFromJSON(json: any): GranularPnoEntries {
    return GranularPnoEntriesFromJSONTyped(json, false);
}

export function GranularPnoEntriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GranularPnoEntries {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'pnoEntries': json['pnoEntries'] == null ? undefined : (mapValues(json['pnoEntries'], PnoEntryFromJSON)),
    };
}

export function GranularPnoEntriesToJSON(json: any): GranularPnoEntries {
    return GranularPnoEntriesToJSONTyped(json, false);
}

export function GranularPnoEntriesToJSONTyped(value?: GranularPnoEntries | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'pnoEntries': value['pnoEntries'] == null ? undefined : (mapValues(value['pnoEntries'], PnoEntryToJSON)),
    };
}

